import {MeasurementUnitType} from '@wix/wixstores-graphql-schema/dist/es/src';

export const unitsTranslations = {
  [MeasurementUnitType.mg]: {
    abbr: 'productWidget.units.mg.label',
    singular: 'productWidget.sr.units.milligram.label',
    plural: 'productWidget.sr.units.milligrams.label',
  },
  [MeasurementUnitType.g]: {
    abbr: 'productWidget.units.g.label',
    singular: 'productWidget.sr.units.gram.label',
    plural: 'productWidget.sr.units.grams.label',
  },
  [MeasurementUnitType.kg]: {
    abbr: 'productWidget.units.kg.label',
    singular: 'productWidget.sr.units.kilogram.label',
    plural: 'productWidget.sr.units.kilograms.label',
  },
  [MeasurementUnitType.ml]: {
    abbr: 'productWidget.units.ml.label',
    singular: 'productWidget.sr.units.milliliter.label',
    plural: 'productWidget.sr.units.milliliters.label',
  },
  [MeasurementUnitType.cl]: {
    abbr: 'productWidget.units.cl.label',
    singular: 'productWidget.sr.units.centiliter.label',
    plural: 'productWidget.sr.units.centiliters.label',
  },
  [MeasurementUnitType.l]: {
    abbr: 'productWidget.units.l.label',
    singular: 'productWidget.sr.units.liter.label',
    plural: 'productWidget.sr.units.liters.label',
  },
  [MeasurementUnitType.cbm]: {
    abbr: 'productWidget.units.cbm.label',
    singular: 'productWidget.sr.units.cubicMeter.label',
    plural: 'productWidget.sr.units.cubicMeters.label',
  },
  [MeasurementUnitType.mm]: {
    abbr: 'productWidget.units.mm.label',
    singular: 'productWidget.sr.units.millimeter.label',
    plural: 'productWidget.sr.units.millimeters.label',
  },
  [MeasurementUnitType.cm]: {
    abbr: 'productWidget.units.cm.label',
    singular: 'productWidget.sr.units.centimeter.label',
    plural: 'productWidget.sr.units.centimeters.label',
  },
  [MeasurementUnitType.m]: {
    abbr: 'productWidget.units.m.label',
    singular: 'productWidget.sr.units.meters.label',
    plural: 'productWidget.sr.units.meters.label',
  },
  [MeasurementUnitType.sqm]: {
    abbr: 'productWidget.units.sqm.label',
    singular: 'productWidget.sr.units.squareMeter.label',
    plural: 'productWidget.sr.units.squareMeters.label',
  },
  [MeasurementUnitType.oz]: {
    abbr: 'productWidget.units.oz.label',
    singular: 'productWidget.sr.units.ounce.label',
    plural: 'productWidget.sr.units.ounces.label',
  },
  [MeasurementUnitType.lb]: {
    abbr: 'productWidget.units.lb.label',
    singular: 'productWidget.sr.units.pound.label',
    plural: 'productWidget.sr.units.pounds.label',
  },
  [MeasurementUnitType.floz]: {
    abbr: 'productWidget.units.flOz.label',
    singular: 'productWidget.sr.units.fluidOunce.label',
    plural: 'productWidget.sr.units.fluidOunces.label',
  },
  [MeasurementUnitType.pt]: {
    abbr: 'productWidget.units.pt.label',
    singular: 'productWidget.sr.units.pint.label',
    plural: 'productWidget.sr.units.pints.label',
  },
  [MeasurementUnitType.qt]: {
    abbr: 'productWidget.units.qt.label',
    singular: 'productWidget.sr.units.quart.label',
    plural: 'productWidget.sr.units.quarts.label',
  },
  [MeasurementUnitType.gal]: {
    abbr: 'productWidget.units.gal.label',
    singular: 'productWidget.sr.units.gallon.label',
    plural: 'productWidget.sr.units.gallons.label',
  },
  [MeasurementUnitType.in]: {
    abbr: 'productWidget.units.in.label',
    singular: 'productWidget.sr.units.inch.label',
    plural: 'productWidget.sr.units.inches.label',
  },
  [MeasurementUnitType.ft]: {
    abbr: 'productWidget.units.ft.label',
    singular: 'productWidget.sr.units.foot.label',
    plural: 'productWidget.sr.units.feet.label',
  },
  [MeasurementUnitType.yd]: {
    abbr: 'productWidget.units.yd.label',
    singular: 'productWidget.sr.units.yard.label',
    plural: 'productWidget.sr.units.yards.label',
  },
  [MeasurementUnitType.sqft]: {
    abbr: 'productWidget.units.sqf.label',
    singular: 'productWidget.sr.units.squareFoot.label',
    plural: 'productWidget.sr.units.squareFeet.label',
  },
};
